import type { FC } from 'react'
import { faArrowRightArrowLeft, faAdd } from '@fortawesome/free-solid-svg-icons'
import {
  Menu,
  MenuItem,
  MenuSeparator,
} from '../../components/interactives/dropdown-menu'
import { useNavigate, useOutletContext } from 'react-router-dom'
import type { Team } from '@rundown-studio/types'

type DashboardContext = {
  team: Team
  teams: Team[]
}

export const TeamSwitcher: FC = () => {
  const { team, teams: userTeams } = useOutletContext<DashboardContext>()
  const navigate = useNavigate()

  const handleSwitchTeam = (teamId: string) => {
    localStorage.setItem('teamId', teamId)
    navigate(`/dashboard/${teamId}`)
  }

  const handleCreateTeam = () => {
    navigate('/create-team')
  }

  if (!team || !userTeams) return null

  return (
    <div className="w-full px-2 flex flex-col gap-2">
      <p className="text-xs mb-1 text-gray-500 font-semibold">Team</p>

      <Menu
        label={team.name || 'My team'}
        icon={faArrowRightArrowLeft}
        className="w-full disabled:opacity-100 disabled:bg-gray-900"
        placement="right"
      >
        {userTeams?.map(({ id, name }) => (
          <MenuItem
            key={id}
            active={id === team.id}
            label={name}
            onClick={() => handleSwitchTeam(id)}
          />
        ))}
        <MenuSeparator key="divider" />
        <MenuItem
          key="new-team"
          label="Create new team"
          onClick={handleCreateTeam}
          icon={faAdd}
        />
      </Menu>
    </div>
  )
}
